import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { AdminLayout } from "@/app/routes/admin-layout";
import { DashboardPage } from "@/app/routes/admin-dashboard";
import { LoginPage } from "@/app/routes/admin-login";
import { QuoteEditPage } from "@/app/routes/admin-quote-edit";
import { QuoteNewPage } from "@/app/routes/admin-quote-new";
import { QuotePreviewPage } from "@/app/routes/admin-quote-preview";
import { QuotationsPage } from "@/app/routes/admin-quotations";
import { SettingsPage } from "@/app/routes/admin-settings";
import { PublicQuotePage } from "@/app/routes/public-quote";
import { AppSettingsProvider } from "@/components/app-settings/app-settings-provider";
import { AuthProvider } from "@/components/auth/auth-provider";
import { ProtectedAdminRoute } from "@/components/auth/protected-admin-route";
import { workbenchRoutePatterns, workbenchRoutes } from "@/lib/routes/workbench-routes";
import "@/app/styles/global.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppSettingsProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to={workbenchRoutes.dashboard} replace />} />
            <Route path={workbenchRoutePatterns.login} element={<LoginPage />} />
            <Route
              element={
                <ProtectedAdminRoute>
                  <AdminLayout />
                </ProtectedAdminRoute>
              }
            >
              <Route path={workbenchRoutePatterns.dashboard} element={<DashboardPage />} />
              <Route path={workbenchRoutePatterns.quotations} element={<QuotationsPage />} />
              <Route path={workbenchRoutePatterns.newQuotation} element={<QuoteNewPage />} />
              <Route path={workbenchRoutePatterns.quotationEdit} element={<QuoteEditPage />} />
              <Route path={workbenchRoutePatterns.quotationPreview} element={<QuotePreviewPage />} />
              <Route path={workbenchRoutePatterns.settings} element={<SettingsPage />} />
              <Route path={workbenchRoutePatterns.settingsSection} element={<SettingsPage />} />
            </Route>
            <Route path="/q/:token" element={<PublicQuotePage />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </AppSettingsProvider>
  </React.StrictMode>,
);
